import { useState, useEffect } from 'react';
import { ObserveNetworkStatusUseCase } from '@/application/use-cases/ObserveNetworkStatusUseCase';
import { BrowserNetworkStatusRepository } from '@/infrastructure/repositories/BrowserNetworkStatusRepository';
import { isOnline } from '@/domain/entities/NetworkStatus';

const repository = new BrowserNetworkStatusRepository();
const useCase = new ObserveNetworkStatusUseCase(repository);

/**
 * Hook que encapsula a observação do status de rede.
 * Retorna `true` quando online e `false` quando offline.
 */
export function useNetworkStatus(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    isOnline(useCase.getCurrentStatus())
  );

  useEffect(() => {
    const unsubscribe = useCase.subscribe((status) => {
      setOnline(isOnline(status));
    });

    return unsubscribe;
  }, []);

  return online;
}
